import React from 'react';
import { reasons } from '../data/content';
import useReveal from '../hooks/useReveal';
import './Why.css';

function Reason({ title, sub }) {
  return (
    <div className="reason">
      <div className="reason__check" aria-hidden="true">✓</div>
      <div className="reason__text">
        <strong>{title}</strong>
        <span>{sub}</span>
      </div>
    </div>
  );
}

export default function Why() {
  const leftRef  = useReveal();
  const rightRef = useReveal();

  return (
    <section className="why" id="why">
      <div className="why__inner">
        {/* Left */}
        <div ref={leftRef}>
          <span className="section-label">Why Choose Us</span>
          <h2 className="section-title">
            Cleaning You Can<br />
            <em>Rely On</em>
          </h2>
          <div className="why__reasons">
            {reasons.map((r) => (
              <Reason key={r.title} {...r} />
            ))}
          </div>
        </div>

        {/* Right: CTA box */}
        <div className="why__cta-box" ref={rightRef}>
          <div className="why__cta-blob why__cta-blob--tr" aria-hidden="true" />
          <div className="why__cta-blob why__cta-blob--bl" aria-hidden="true" />
          <h3>
            Ready for a <em>Spotless</em> Space?
          </h3>
          <p>
            Contact us today for a free consultation and a quote tailored
            specifically to your home or business. Let Fresh Wave Solutions
            handle the cleaning so you don't have to.
          </p>
          <a href="#contact" className="why__cta-btn">Get a Free Quote</a>
        </div>
      </div>
    </section>
  );
}
